const PRODUCTION_HOST = 'app.rely.business';
const DOWNGRADE_TRAFFIC_CLASSES = ['internal', 'synthetic'];

export const resolveTrafficOverride = (search, configuredOverride) => {
  const runtimeOverride = new URLSearchParams(search || '').get('rely_traffic_class');
  if (DOWNGRADE_TRAFFIC_CLASSES.includes(runtimeOverride)) return runtimeOverride;
  return DOWNGRADE_TRAFFIC_CLASSES.includes(configuredOverride)
    ? configuredOverride
    : undefined;
};

const environmentForHostname = (hostname) => {
  const normalized = String(hostname || '').trim().toLowerCase();
  if (normalized === PRODUCTION_HOST) return 'production';
  if (normalized === 'app-dev.rely.business' || normalized.includes('app-dev')) {
    return 'dev';
  }
  if (normalized === 'localhost' || normalized === '127.0.0.1') return 'local';
  if (normalized.endsWith('.pages.dev') || normalized.endsWith('.vercel.app')) {
    return 'preview';
  }
  return 'dev';
};

export const buildAnalyticsContext = (
  hostname,
  trafficOverride = process.env.REACT_APP_RELY_TRAFFIC_CLASS
) => {
  const rely_environment = environmentForHostname(hostname);
  const requestedClass = DOWNGRADE_TRAFFIC_CLASSES.includes(trafficOverride)
    ? trafficOverride
    : null;

  return {
    rely_environment,
    surface: 'app',
    traffic_class:
      requestedClass ||
      (rely_environment === 'production' ? 'commercial' : 'internal'),
    event_schema_version: 2,
  };
};

